// import React, { useState, useRef, useEffect } from "react";
// import { WebApiURL } from "../Constants/Constants";

// function OtpRegisterForm({ setActiveForm, source }) {
//   const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
//   const [statusMessage, setStatusMessage] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isResending, setIsResending] = useState(false);
//   const inputsRef = useRef([]);

//   const handleChange = (index, value) => {
//     if (!/^[0-9]?$/.test(value)) return;
//     const newOtp = [...otpDigits];
//     newOtp[index] = value;
//     setOtpDigits(newOtp);
//     if (value && index < 5) inputsRef.current[index + 1]?.focus();
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
//       inputsRef.current[index - 1]?.focus();
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const otp = otpDigits.join("");
//     setStatusMessage("");
//     setIsSubmitting(true);

//     try {
//       const email = localStorage.getItem("email");
//       if (!email) {
//         setStatusMessage("Session expired. Please try again.");
//         setIsSubmitting(false);
//         return;
//       }

//       const response = await fetch(`${WebApiURL}Verification/verify-registration-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, otp }),
//       });

//       const text = await response.text();
//       let data;
//       try {
//         data = JSON.parse(text);
//       } catch {
//         data = { message: text };
//       }

//       if (response.ok) {
//         setStatusMessage("✅ OTP verified successfully!");

//         // Save user info in localStorage
//         if (data.user) {
//           localStorage.setItem("user", JSON.stringify(data.user));
//         }

//         localStorage.removeItem("email");

//         // ✅ Switch to RegisterConfirm screen
//         setTimeout(() => {
//           setActiveForm("registerConfirm");
//         }, 500);

//       } else {
//         setStatusMessage(data.message || "Invalid OTP. Please try again.");
//       }
//     } catch (err) {
//       console.error(err);
//       setStatusMessage("Server error or network issue.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleResend = async () => {
//     setIsResending(true);
//     setStatusMessage("");

//     try {
//       const email = localStorage.getItem("email");
//       if (!email) {
//         setStatusMessage("Session expired. Please try again.");
//         setIsResending(false);
//         return;
//       }

//       const response = await fetch(`${WebApiURL}Verification/resend-registration-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email }),
//       });

//       const text = await response.text();
//       let data;
//       try {
//         data = JSON.parse(text);
//       } catch {
//         data = { message: text };
//       }

//       if (response.ok) {
//         setOtpDigits(["", "", "", "", "", ""]);
//         inputsRef.current[0]?.focus();
//         setStatusMessage("✅ OTP resent successfully!");
//       } else {
//         setStatusMessage(data.message || "Failed to resend OTP.");
//       }
//     } catch (err) {
//       console.error(err);
//       setStatusMessage("Server error or network issue.");
//     } finally {
//       setIsResending(false);
//     }
//   };

//   useEffect(() => {
//     if (!statusMessage) return;
//     const timer = setTimeout(() => setStatusMessage(""), 5000);
//     return () => clearTimeout(timer);
//   }, [statusMessage]);

//   return (
//     <div className="max-564 w-100 rounded-1 border p-4">
//       <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
//         OTP Verification
//       </div>

//       {statusMessage && (
//         <div className={`alert ${statusMessage.includes("success") ? "alert-success" : "alert-danger"}`}>
//           {statusMessage}
//         </div>
//       )}

//       <form onSubmit={handleSubmit}>
//         <div className="form-group mb-3">
//           <label className="form-label font-17 font-400 text-primary-green mb-1">Enter OTP</label>
//           <div className="d-flex justify-content-between gap-2">
//             {otpDigits.map((digit, index) => (
//               <input
//                 key={index}
//                 type="text"
//                 inputMode="numeric"
//                 maxLength="1"
//                 className="form-control text-center height-40 rounded-1 border-color-7D9199"
//                 value={digit}
//                 onChange={(e) => handleChange(index, e.target.value)}
//                 onKeyDown={(e) => handleKeyDown(index, e)}
//                 ref={(el) => (inputsRef.current[index] = el)}
//               />
//             ))}
//           </div>
//         </div>

//         <button type="submit" className="btn btn-primary-green w-100 height-50 rounded-1" disabled={isSubmitting}>
//           {isSubmitting ? "Verifying..." : "Verify OTP"}
//         </button>

//         <div className="form-group d-flex justify-content-between mt-3">
//           <button
//             type="button"
//             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
//             onClick={() => setActiveForm("login")}
//           >
//             ← Back to Login
//           </button>
//           <button
//             type="button"
//             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
//             onClick={handleResend}
//             disabled={isResending}
//           >
//             {isResending ? "Resending..." : "Resend OTP"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default OtpRegisterForm;

import React, { useState, useRef, useEffect } from "react";
import { WebApiURL } from "../Constants/Constants";

function OtpRegisterForm({ setActiveForm, source }) {
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [statusMessage, setStatusMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const inputsRef = useRef([]);

  const handleChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;
    const newOtp = [...otpDigits];
    newOtp[index] = value;
    setOtpDigits(newOtp);
    if (value && index < 5) inputsRef.current[index + 1]?.focus();
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const otp = otpDigits.join("");
    setStatusMessage("");
    setIsSubmitting(true);

    try {
      const email = localStorage.getItem("email");
      if (!email) {
        setStatusMessage("Session expired. Please try again.");
        setIsSubmitting(false);
        return;
      }

      const response = await fetch(`${WebApiURL}Verification/verify-registration-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        data = { message: text };
      }

      if (response.ok) {
        setStatusMessage("✅ OTP verified successfully!");

        // Save user info in localStorage
        if (data.user) {
          localStorage.setItem("user", JSON.stringify(data.user));
        }

        localStorage.removeItem("email");

        // ✅ Switch to RegisterConfirm screen
        setTimeout(() => {
          setActiveForm("registerConfirm");
        }, 500);

      } else {
        setStatusMessage(data.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setStatusMessage("Server error or network issue.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleResend = async () => {
    setIsResending(true);
    setStatusMessage("");

    try {
      const email = localStorage.getItem("email");
      if (!email) {
        setStatusMessage("Session expired. Please try again.");
        setIsResending(false);
        return;
      }

      const response = await fetch(`${WebApiURL}Verification/resend-registration-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        data = { message: text };
      }

      if (response.ok) {
        setOtpDigits(["", "", "", "", "", ""]);
        inputsRef.current[0]?.focus();
        setStatusMessage("✅ OTP resent successfully!");
      } else {
        setStatusMessage(data.message || "Failed to resend OTP.");
      }
    } catch (err) {
      console.error(err);
      setStatusMessage("Server error or network issue.");
    } finally {
      setIsResending(false);
    }
  };

  useEffect(() => {
    if (!statusMessage) return;
    const timer = setTimeout(() => setStatusMessage(""), 5000);
    return () => clearTimeout(timer);
  }, [statusMessage]);

  return (
    <div className="max-564 w-100 rounded-1 border p-4">
      <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
        OTP Verification
      </div>

      {statusMessage && (
        <div className={`alert ${statusMessage.includes("success") ? "alert-success" : "alert-danger"}`}>
          {statusMessage}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <label className="form-label font-17 font-400 text-primary-green mb-1">Enter OTP</label>
          <div className="d-flex justify-content-between gap-2">
            {otpDigits.map((digit, index) => (
              <input
                key={index}
                type="text"
                inputMode="numeric"
                maxLength="1"
                className="form-control text-center height-40 rounded-1 border-color-7D9199"
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                ref={(el) => (inputsRef.current[index] = el)}
              />
            ))}
          </div>
        </div>

        <button type="submit" className="btn btn-primary-green w-100 height-50 rounded-1" disabled={isSubmitting}>
          {isSubmitting ? "Verifying..." : "Verify OTP"}
        </button>

        <div className="form-group d-flex justify-content-between mt-3">
          <button
            type="button"
            className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
            onClick={() => setActiveForm("login")}
          >
            ← Back to Login
          </button>
          <button
            type="button"
            className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
            onClick={handleResend}
            disabled={isResending}
          >
            {isResending ? "Resending..." : "Resend OTP"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default OtpRegisterForm;
